import { Link } from "react-router-dom";
import { ASSETS } from '@/constants/assets';

export default function ServicesSection() {
  return (
    <section id="solucoes" className="relative bg-gp-graphite py-24 overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-0 w-full h-full" style={{
          backgroundImage: 'radial-gradient(circle at 1px 1px, rgba(255,255,255,0.15) 1px, transparent 0)',
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      <div className="relative z-10 px-4 sm:px-6 lg:px-12">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-3 mb-6">
            <div className="w-8 h-[2px] bg-gp-yellow"></div>
            <span className="text-gp-yellow text-sm uppercase tracking-[0.3em] font-medium">O Que Fazemos</span>
            <div className="w-8 h-[2px] bg-gp-yellow"></div>
          </div>
          <h2 className="font-display text-4xl md:text-5xl font-bold text-white uppercase">
            Como Podemos <span className="text-gp-yellow">Ajudar Sua Operação</span>
          </h2>
          <p className="text-gray-400 mt-4 max-w-3xl mx-auto">
            Quatro pilares comerciais integrados para entregar confiabilidade operacional, redução de paradas e aumento da disponibilidade dos seus ativos industriais.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {/* Card 1: Oficina Especializada */}
          <Link
            to="/oficina"
            className="group relative overflow-hidden rounded-lg block hover:ring-1 hover:ring-gp-yellow/50 hover:shadow-lg hover:shadow-gp-yellow/10 transition-all duration-300"
          >
            <div className="relative h-[320px] overflow-hidden">
              <img
                src={ASSETS.comoPodemosAjudar01}
                alt="Oficina Especializada - Recuperação de Equipamentos Hidráulicos"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-gp-graphite via-gp-graphite/40 to-transparent"></div>
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-6 flex flex-col">
              <div className="flex items-center gap-3 mb-3 flex-shrink-0">
                <div className="w-10 h-10 bg-gp-yellow rounded-sm flex items-center justify-center flex-shrink-0">
                  <i className="ri-hammer-line text-gp-graphite text-lg w-6 h-6 flex items-center justify-center"></i>
                </div>
                <span className="text-gp-yellow text-xs uppercase tracking-wider font-semibold">Recuperação</span>
              </div>
              <h3 className="font-display text-xl font-bold text-white uppercase mb-2 min-h-[3.5rem] leading-tight line-clamp-2">
                Oficina Especializada
              </h3>
              <div className="max-h-0 overflow-hidden group-hover:max-h-[200px] transition-all duration-300">
                <p className="text-gray-300 text-sm leading-relaxed">
                  Recuperação de cilindros, bombas, motores e redutores hidráulicos. Reparo especializado de gruas florestais e equipamentos para celulose com foco em confiabilidade operacional.
                </p>
              </div>
            </div>
          </Link>

          {/* Card 2: DURAFLOW */}
          <Link
            to="/equipamentos-e-componentes"
            className="group relative overflow-hidden rounded-lg block hover:ring-1 hover:ring-gp-yellow/50 hover:shadow-lg hover:shadow-gp-yellow/10 transition-all duration-300"
          >
            <div className="relative h-[320px] overflow-hidden">
              <img
                src={ASSETS.comoPodemosAjudar02}
                alt="DURAFLOW - Componentes Hidráulicos Industriais"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-gp-graphite via-gp-graphite/40 to-transparent"></div>
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-6 flex flex-col">
              <div className="flex items-center gap-3 mb-3 flex-shrink-0">
                <div className="w-10 h-10 bg-gp-yellow rounded-sm flex items-center justify-center flex-shrink-0">
                  <i className="ri-store-3-line text-gp-graphite text-lg w-6 h-6 flex items-center justify-center"></i>
                </div>
                <span className="text-gp-yellow text-xs uppercase tracking-wider font-semibold">Componentes</span>
              </div>
              <h3 className="font-display text-xl font-bold text-white uppercase mb-2 min-h-[3.5rem] leading-tight line-clamp-2">
                DURAFLOW
              </h3>
              <div className="max-h-0 overflow-hidden group-hover:max-h-[200px] transition-all duration-300">
                <p className="text-gray-300 text-sm leading-relaxed">
                  Venda de mangueiras, bombas, motores, cilindros, válvulas e acessórios hidráulicos de alta qualidade com padrão internacional para toda a indústria brasileira.
                </p>
              </div>
            </div>
          </Link>

          {/* Card 3: Serviços de Campo */}
          <Link
            to="/servicos-de-campo"
            className="group relative overflow-hidden rounded-lg block hover:ring-1 hover:ring-gp-yellow/50 hover:shadow-lg hover:shadow-gp-yellow/10 transition-all duration-300"
          >
            <div className="relative h-[320px] overflow-hidden">
              <img
                src={ASSETS.comoPodemosAjudar03}
                alt="Serviços de Campo - Manutenção Industrial em Planta"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-gp-graphite via-gp-graphite/40 to-transparent"></div>
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-6 flex flex-col">
              <div className="flex items-center gap-3 mb-3 flex-shrink-0">
                <div className="w-10 h-10 bg-gp-yellow rounded-sm flex items-center justify-center flex-shrink-0">
                  <i className="ri-settings-5-line text-gp-graphite text-lg w-6 h-6 flex items-center justify-center"></i>
                </div>
                <span className="text-gp-yellow text-xs uppercase tracking-wider font-semibold">Campo</span>
              </div>
              <h3 className="font-display text-xl font-bold text-white uppercase mb-2 min-h-[3.5rem] leading-tight line-clamp-2">
                Serviços de Campo
              </h3>
              <div className="max-h-0 overflow-hidden group-hover:max-h-[200px] transition-all duration-300">
                <p className="text-gray-300 text-sm leading-relaxed">
                  Atendimento técnico especializado diretamente em sua planta industrial. Mecânica, hidráulica, caldeiraria, solda e lubrificação industrial com equipe qualificada.
                </p>
              </div>
            </div>
          </Link>

          {/* Card 4: Locação de Equipamentos */}
          <Link
            to="/locacao-equipamentos-industriais"
            className="group relative overflow-hidden rounded-lg block hover:ring-1 hover:ring-gp-yellow/50 hover:shadow-lg hover:shadow-gp-yellow/10 transition-all duration-300"
          >
            <div className="relative h-[320px] overflow-hidden">
              <img
                src={ASSETS.comoPodemosAjudar04}
                alt="Locação de Equipamentos Industriais"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-gp-graphite via-gp-graphite/40 to-transparent"></div>
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-6 flex flex-col">
              <div className="flex items-center gap-3 mb-3 flex-shrink-0">
                <div className="w-10 h-10 bg-gp-yellow rounded-sm flex items-center justify-center flex-shrink-0">
                  <i className="ri-truck-line text-gp-graphite text-lg w-6 h-6 flex items-center justify-center"></i>
                </div>
                <span className="text-gp-yellow text-xs uppercase tracking-wider font-semibold">Locação</span>
              </div>
              <h3 className="font-display text-xl font-bold text-white uppercase mb-2 min-h-[3.5rem] leading-tight line-clamp-2">
                Locação de Equipamentos
              </h3>
              <div className="max-h-0 overflow-hidden group-hover:max-h-[200px] transition-all duration-300">
                <p className="text-gray-300 text-sm leading-relaxed">
                  Locação de equipamentos industriais para apoio em manutenção, filtragem de óleo, operações hidráulicas e suporte técnico em campo. Termovácuo, bombas e sistemas auxiliares.
                </p>
              </div>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}